import AOS from "aos";
import $ from "jquery";

/**
 * See https://github.com/michalsnik/aos
 */
export class AosModule {
    constructor() {
        this.setAOSOnEditorcontent();

        AOS.init({
            offset: 80,
            duration: 300,
            easing: "ease-out-quad"
        });



    }

    setAOSOnEditorcontent() {
        /*$(".video-embed-block__content__inner h2").attr("data-aos", "fade-up");
        $(".video-embed-block__content__inner h3").attr("data-aos", "fade-up");
        $(".video-embed-block__content__inner h4").attr("data-aos", "fade-up");
        $(".video-embed-block__content__inner p").attr("data-aos", "fade-up");
        $(".video-embed-block__content__inner a").attr("data-aos", "fade-up");

        $(".content-block__inner__content h2").attr("data-aos", "fade-up");
        $(".content-block__inner__content h3").attr("data-aos", "fade-up");
        $(".content-block__inner__content h4").attr("data-aos", "fade-up");
        $(".content-block__inner__content h5").attr("data-aos", "fade-up");
        $(".content-block__inner__content h6").attr("data-aos", "fade-up");
        $(".content-block__inner__content p").attr("data-aos", "fade-up");
        $(".content-block__inner__content a").attr("data-aos", "fade-up");
        $(".content-block__inner__content ul").attr("data-aos", "fade-up");
        $(".content-block__inner__content ol").attr("data-aos", "fade-up");
        $(".content-block__inner__content img").attr("data-aos", "fade-up");

        $(".footer-nav-menu .menu-item").attr("data-aos", "fade-up");
*/

    }

}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/AosModule.js